(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["datu-edition-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-edition-picker')) {
    customElements.define('datu-edition-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.productInfo = this.closest('.product-info');
        this.productInfo.addEventListener('click', (event) => {
          const link = event.target.closest('a[href]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href, location.origin);
          if (url.origin !== location.origin || !url.pathname.endsWith('/products/' + this.dataset.digitalHandle)) return;
          event.preventDefault();
          const radio = this.querySelector('input[value="digital"]');
          radio.checked = true;
          radio.focus({preventScroll: true});
          this.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["datu-entry-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-entry-promo')) {
    customElements.define('datu-entry-promo', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => this.update();
        window.addEventListener('pageshow', this.refresh);
        document.addEventListener('visibilitychange', this.refresh);
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('pageshow', this.refresh);
        document.removeEventListener('visibilitychange', this.refresh);
      }
      update() {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = Number(this.dataset.start);
        const end = Number(this.dataset.end);
        const active = Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
        const offer = this.querySelector('[data-promo-offer]');
        const fallback = this.querySelector('[data-promo-fallback]');
        if (offer) offer.hidden = !active;
        if (fallback) fallback.hidden = active;
        this.toggleAttribute('data-inactive', !active);
        const boundary = now < start ? start : end;
        if (now < boundary) this.timer = setTimeout(this.refresh, Math.min(boundary - now + 20, 60000));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["datu-format-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-format-preview')) {
  customElements.define('datu-format-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.classList.contains('datu-format-preview--product')) return;
      this.controller = new AbortController();
      this.dataset.formId ||= this.closest('product-rerender')?.getAttribute('observe-form') || '';
      document.addEventListener('variant:change', event => {
        if (event.target?.getAttribute?.('id') !== this.dataset.formId || !event.detail?.variant) return;
        const options = event.detail.variant.options;
        const dimensions = options[0].split('x').map(Number);
        if (dimensions.length !== 2 || dimensions.some(value => !Number.isFinite(value) || value <= 0)) return;
        const [height, width] = dimensions;
        const mat = options[2] === 'Mats' && options[1] !== 'Unframed';
        const openings = { '8x12': [8, 6], '12x18': [17, 11], '16x24': [16, 12], '20x30': [24, 18], '24x36': [30, 20] };
        const opening = mat ? (this.dataset.square === 'true' ? [width - 4, height - 4] : openings[options[0]]) : [width, height];
        if (!opening) return;
        const stage = this.querySelector('.datu-format-stage');
        stage.dataset.datuFinish = options[1].toLowerCase().replaceAll(' ', '-');
        stage.dataset.mat = String(mat);
        stage.style.setProperty('--datu-paper-ratio', `${width} / ${height}`);
        stage.style.setProperty('--datu-opening-width', `${opening[0] / width * 100}%`);
        stage.style.setProperty('--datu-opening-height', `${opening[1] / height * 100}%`);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["datu-pick-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-featured-purchase')) {
  customElements.define('datu-featured-purchase', class extends HTMLElement {
    static pendingVariants = new Set();
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.label = this.querySelector('[data-pick-button-label]');
      this.status = this.querySelector('[data-pick-status]');
      this.error = this.querySelector('[data-pick-error]');
      this.cartLink = this.querySelector('[data-pick-cart-link]');
      this.messages = JSON.parse(this.querySelector('[data-pick-messages]').textContent);
      this.initialLabel = this.label.textContent;
      this.form.addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async add(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled || this.constructor.pendingVariants.has(this.dataset.variantId) || !this.form.reportValidity()) return;
      this.constructor.pendingVariants.add(this.dataset.variantId);
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.label.textContent = this.messages.adding;
      this.status.hidden = true;
      this.error.hidden = true;
      this.cartLink.hidden = true;
      let accepted = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const body = new FormData(this.form);
        body.set('id', this.dataset.variantId);
        body.set('quantity', '1');
        body.set('sections', sections.join(','));
        body.set('sections_url', this.dataset.sectionsUrl);
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const result = await response.json();
        if (!response.ok) {
          this.error.textContent = typeof result.description === 'string' ? result.description : this.messages.error;
          this.error.hidden = false;
          return;
        }
        accepted = true;
        document.dispatchEvent(new CustomEvent('datu:featured-added', { detail: { variantId: this.dataset.variantId } }));
        this.status.textContent = this.messages.added;
        this.status.hidden = false;
        this.cartLink.hidden = false;
        const cartResponse = await fetch(this.dataset.cartUrl);
        if (!cartResponse.ok) throw new Error('cart-refresh');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        this.form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items || [result], cart, onSuccessDo: null } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: null, cart } }));
      } catch (error) {
        if (accepted) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          this.error.textContent = this.messages.uncertain;
          this.error.hidden = false;
          this.cartLink.hidden = false;
        }
      } finally {
        this.busy = false;
        this.constructor.pendingVariants.delete(this.dataset.variantId);
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.label.textContent = this.initialLabel;
      }
    }
  });
}
if (!customElements.get('datu-pick-entries')) {
  customElements.define('datu-pick-entries', class extends HTMLElement {
    static configuration = new Map();
    connectedCallback() { this.verify(); }
    async verify() {
      const line = this.querySelector('[data-pick-entries]');
      const basis = this.querySelector('[data-pick-entry-basis]');
      line.hidden = true;
      basis.hidden = true;
      try {
        const query = 'query QuerySweepstakeDetailsByProductId($platform: String!, $platformId: String!, $productIds: [String!]) { sweepstakeDetailsByProductId(platform: $platform, platformId: $platformId, productIds: $productIds) { id entryManagement productsAllowedByDefault bonusEntriesDefault membershipProductMultOverride scheduledBonusValue scheduledBonusActive products(productIds: $productIds) { productId productAllowed productBonusEntries productMultiplier } } }';
        if (!this.constructor.configuration.has(this.dataset.productId)) {
          this.constructor.configuration.set(this.dataset.productId, fetch('https://backend.cleansweeps.app/graphql', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query, variables: { platform: 'Shopify', platformId: 'gid://shopify/Shop/73498361939', productIds: ['gid://shopify/Product/' + this.dataset.productId] } }), signal: AbortSignal.timeout(8000) }).then(response => response.ok ? response.json() : null));
        }
        const result = await this.constructor.configuration.get(this.dataset.productId);
        if (!result) return;
        const giveaway = result.data?.sweepstakeDetailsByProductId?.find(item => String(item.id) === '13883');
        if (!giveaway || giveaway.scheduledBonusActive || giveaway.membershipProductMultOverride) return;
        const rules = JSON.parse(giveaway.entryManagement);
        if (Number(rules.entryPer) !== 1 || Number(rules.dollarSpent) !== 1 || rules.roundUp !== true || rules.bonusSpending) return;
        const productId = 'gid://shopify/Product/' + this.dataset.productId;
        const product = giveaway.products?.find(item => item.productId === productId);
        if (product) {
          if (!product.productAllowed || Number(product.productMultiplier) !== 1 || Number(product.productBonusEntries) !== 0) return;
        } else if (!giveaway.productsAllowedByDefault || Number(giveaway.bonusEntriesDefault) !== 0) return;
        const price = Number(this.dataset.price);
        if (!Number.isFinite(price) || price < 0) return;
        const count = Math.ceil(price / 100);
        const template = JSON.parse(this.querySelector('[data-pick-entry-message]').textContent);
        line.textContent = template.replace('[count]', count.toLocaleString());
        line.hidden = false;
        basis.hidden = false;
      } catch (error) {}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["datu-print-previews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-print-options')) {
  customElements.define('datu-print-options', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.select = this.querySelector('[data-datu-frame]');
      this.card = this.closest('[data-datu-frame-card]');
      this.stage = this.card?.querySelector('.datu-framed-stage');
      if (!this.select || !this.stage || !this.select.options.length) return;
      this.abortController = new AbortController();
      this.select.addEventListener('change', () => this.update(), { signal: this.abortController.signal });
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
    update() {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      this.stage.dataset.datuFinish = option.value;
      const price = this.card.querySelector('[data-datu-framed-price]');
      const configuration = this.card.querySelector('[data-datu-card-configuration]');
      if (price) price.textContent = option.dataset.price;
      if (configuration) configuration.textContent = option.dataset.configuration;
      this.card.querySelectorAll('[data-datu-product-link]').forEach(link => {
        link.href = option.dataset.url;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["datu-product-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('datu-product-preview')) {
  customElements.define('datu-product-preview', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.querySelector('product-gallery');
      this.fallback = this.querySelector('[data-datu-artwork-fallback]');
      this.stage = this.querySelector('[data-datu-fallback-stage]');
      if (!this.gallery || !this.fallback) return;
      this.controller = new AbortController();
      this.dataset.formId ||= this.closest('product-rerender')?.getAttribute('observe-form') || '';
      document.addEventListener('variant:change', event => {
        if (event.target?.getAttribute?.('id') !== this.dataset.formId || !event.detail?.variant || !this.stage) return;
        const options = event.detail.variant.options;
        this.stage.dataset.frame = options[1].toLowerCase().replaceAll(' ', '-');
        this.stage.dataset.mat = options[2] === 'Mats' ? 'yes' : 'no';
      }, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'width', 'height'] });
      this.gallery.addEventListener('load', () => this.schedule(), { capture: true, signal: this.controller.signal });
      this.gallery.addEventListener('webglcontextlost', () => { this.fallback.hidden = false; }, { capture: true, signal: this.controller.signal });
      this.schedule();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); cancelAnimationFrame(this.frame); }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const preview = this.gallery.querySelector('.starboard-super-container');
        if (!preview) { this.fallback.hidden = false; return; }
        const media = Array.from(preview.querySelectorAll('canvas, img')).filter(item => item.tagName === 'CANVAS' || !item.alt?.includes('Powered by'));
        this.fallback.hidden = media.some(item => item.getBoundingClientRect().width > 40 && item.getBoundingClientRect().height > 40 && (item.tagName === 'CANVAS' ? item.width > 0 && item.height > 0 : item.complete && item.naturalWidth > 0));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
